import { AppConfig } from '../configs';
import axios from 'axios';

const { BOOKING_URL } = AppConfig;



export const getBookingDetail = (id, token )=> {
    return axios.post(`${BOOKING_URL}/api/v3/public/booking/${id}/getDetails`, {encodedToken: token})
}
